var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95248 0H6.02241C5.74467 0 5.47803 0.110421 5.28157 0.307042L0.306733 5.28598C-0.102244 5.6953 -0.102244 6.35903 0.306733 6.7689L4.22733 10.6931C4.43182 10.8976 4.70011 11 4.96807 11C5.23581 11 5.50355 10.8978 5.70804 10.6937L10.6922 5.71457C10.8893 5.51794 11 5.25087 11 4.97245V1.0485C11 0.469425 10.5311 0 9.95248 0ZM7.84137 4.47891C7.11284 4.47891 6.52005 3.88542 6.52005 3.15607C6.52005 2.42694 7.11284 1.83366 7.84137 1.83366C8.57044 1.83366 9.16334 2.42694 9.16334 3.15607C9.16334 3.88542 8.57044 4.47891 7.84137 4.47891Z",
    fill: "#0090C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTag);
export default __webpack_public_path__ + "static/media/icon-tag.87d29c7c94a7c56b247c4dce6f48c8e8.svg";
export { ForwardRef as ReactComponent };